export const formatDate = (data: string) => {
  const date = new Date(data);

  const horas = date.getHours();
  const minutos = date.getMinutes();

  const horaFormatada = horas > 12 ? horas - 12 : horas;
  const periodo = horas >= 12 ? 'PM' : 'AM';

  const minutosFormatados = minutos.toString().padStart(2, '0');

  return `${horaFormatada}h${minutosFormatados}${periodo}`;
};
